import http from './http'

export default {
  product: {
    get (id) {
      return http.get('/product/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/product/getlist', {
        type: search.type,
        classId: search.productClass,
        keyword: search.keyword,
        status: search.status,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getStockProductList (keyword, pageConfig) {
      return http.get('/product/getstockproductlist', {
        keyword: keyword,
        productClassId: -1,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMerchantProductList (search, pageConfig) {
      return http.get('/product/getmerchantproductlist', {
        selectAccessAccount: search.selectAccessAccount,
        keyword: search.keyword,
        merchantId: search.merchantId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getListByClass (classId) {
      return http.get('/product/getlistbyclass', { classId: classId })
    },
    getStatusList () {
      return http.get('/product/getstatuslist')
    },
    getPricingTypeList () {
      return http.get('/product/getpricingtypelist')
    },
    getProductStockControlTypeList () {
      return http.get('/product/getproductstockcontroltypelist')
    },
    create (model) {
      return http.post('/product/create', model)
    },
    update (model) {
      return http.post('/product/update', model)
    },
    delete (id) {
      return http.post('/product/delete', id)
    }
  },
  productClass: {
    get (id) {
      return http.get('/product/productclass/get', { id: id })
    },
    getList () {
      return http.get('/product/productclass/getlist')
    },
    create (model) {
      return http.post('/product/productclass/create', model)
    },
    update (model) {
      return http.post('/product/productclass/update', model)
    },
    delete (ids) {
      return http.post('/product/productclass/delete', ids)
    }
  },
  productTag: {
    get (id) {
      return http.get('/product/producttag/get', { id: id })
    },
    getList () {
      return http.get('/product/producttag/getlist')
    },
    create (model) {
      return http.post('/product/producttag/create', model)
    },
    update (model) {
      return http.post('/product/producttag/update', model)
    },
    delete (id) {
      return http.post('/product/producttag/delete', id)
    }
  },
  productUnit: {
    get (id) {
      return http.get('/product/productunit/get', { id: id })
    },
    getList () {
      return http.get('/product/productunit/getlist')
    },
    create (model) {
      return http.post('/product/productunit/create', model)
    },
    update (model) {
      return http.post('/product/productunit/update', model)
    },
    delete (id) {
      return http.post('/product/productunit/delete', id)
    }
  },
  supplier: {
    get (id) {
      return http.get('/product/supplier/get', { id: id })
    },
    getList (keyword, pageConfig) {
      return http.get('/product/supplier/getlist', {
        keyword: keyword,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/product/supplier/create', model)
    },
    update (model) {
      return http.post('/product/supplier/update', model)
    },
    delete (id) {
      return http.post('/product/supplier/delete', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/product.js